// 폼 공통 클래스 — 새로 만드는 화면은 이걸 쓴다
export const inputCls =
  'w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-surface text-gray-900 transition-colors ' +
  'hover:border-gray-400 focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/20'

export const labelCls = 'block text-[13px] font-medium text-gray-700 mb-1.5'

export const primaryBtn =
  'inline-flex items-center justify-center gap-2 bg-accent text-on-accent px-4 py-2 rounded-lg text-sm font-medium ' +
  'hover:bg-accent-hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
